<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class=" tw-text-2xl text-secondary tw-font-bold tw-capitalize") {{ $t('Opportunities.Common.editOpportunity') }}
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 tw-pb-0 tw-pl-2 tw-overflow-hidden")
    v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0 tw-pb-0 ")
      v-col(class=" tw-h-full  tw-flex tw-flex-col tw-flex-grow  tw-py-0")
        v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)")

        v-tabs(vertical class="tw-h-full tw-py-0 tw-my-0")
          v-tab
            span {{ $t('Common.description') }}
          //- v-tab
          //-   span Looking for
          v-tab
            span {{ $t('Common.contacts') }}

          //Description
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full tw-overflow-x-scroll")
            v-container(fluid class="tw-px-6")
              v-row
                v-col
                  v-row(dense)
                    v-col
                      v-text-field(
                        v-model="opportunity.name"
                        :label="$t('Common.name')"
                        color="blue darken-4"
                        required
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )
                  v-row(dense)
                    v-col
                      v-textarea(
                        v-model="opportunity.description"
                        :label="$t('Common.description')"
                        color="blue darken-4"
                        required
                        rows="7"
                        height="250"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )
                  v-row(dense justify="space-between")
                    v-col(cols="3")
                      v-menu(v-model="date" :nudge-right="200" :nudge-top="310" offset-y)
                        template(v-slot:activator="{ on, attrs }")
                          v-text-field(
                            :value="formatedDate"
                            :label="$t('Opportunities.Common.decisionBy')"
                            preppend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          )
                        v-date-picker(
                          v-model="opportunity.expected_close_date"
                          @input="date = false"
                          flat
                          no-title
                          dark
                          locale="en"
                          :min="this.$moment().format('YYYY-MM-DD')"
                          :max="this.$moment().add(5, 'years').format('YYYY-MM-DD')"
                          elevation="0"
                          class=" tw-border-none tw-rounded-sm"
                        )
                    v-col(cols="7")
                      v-row(justify="space-between")
                        v-col(cols="4")
                          v-text-field(
                            v-model="opportunity.amount"
                            hide-details
                            type="number"
                            min="0"
                            step="1000"
                            :label="$t('Opportunities.Common.commissionValue')"
                            class="tw-capitalize"
                          )

                        v-col(cols="4")
                          v-text-field(
                            v-model="opportunity.budget_min"
                            hide-details
                            type="number"
                            min="1000"
                            step="10000"
                            :label="$t('Opportunities.Common.startingBudget')"
                            class="tw-capitalize"
                          )
                        v-col(cols="4")
                          v-text-field(
                            v-model="opportunity.budget_max"
                            hide-details
                            min="10000"
                            type="number"
                            step="10000"
                            :label="$t('Opportunities.Common.maxBudget')"
                          )
          //- //Searching for
          //- v-tab-item(transition="fade-transition" reverse-transition="fade-transition" classs="tw-h-full")
          //-   v-container(fluid class="tw-h-full")
          //-     v-row
          //-       v-col
          //-         span ...

          //Contacts
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
            v-container(fluid class="tw-h-full")
              v-row(no-gutters class="tw-h-full tw-pb-2")
                v-col(class="tw-h-full")
                  v-row(no-gutters class="tw-h-full ")
                    v-col(class="tw-h-full")
                      kubiqa-contacts-relate-main(entityType="opportunities")

  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="$emit('close')" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>

<script>
export default {
  data() {
    return {
      opportunity: {},
      date: null,
      loading: false,
      valid: true,
    };
  },
  computed: {
    formatedDate() {
      return this.opportunity.expected_close_date
        ? this.$moment(this.opportunity.expected_close_date).format('dddd, MMMM Do YYYY')
        : '';
    },
  },
  mounted() {
    this.opportunity = JSON.parse(JSON.stringify(this.$store.getters['opportunities/current_opportunity']));
    this.loading = true;
    this.$store.dispatch('opportunities/contacts/getContacts').then(() => {
      this.loading = false;
    });
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch('opportunities/update', this.opportunity).then(() => {
          this.$store.dispatch('opportunities/view', this.opportunity.id).then(() => {
            this.$emit('close');
            this.loading = false;
          });
        });
      }
    },
  },
};
</script>
